<div class="container-fluid new_production_hours_container">
  <div class="container-fluid title_group">
    <h1 class="title_name">
      <!-- <img
        class="menu-bt"
        routerLink="/menu"
        src="../../assets/img/menu.svg"
        alt="menu"
      /> -->
      Production Hours
    </h1>

    <!-- <p>{{ DATA | json }}</p> -->

    <div class="time">
      <!-- <p>10:23 <span>AM</span></p> -->
      <p>{{ this.clock.isRealTimeClock | date: "yyyy/MM/dd HH:mm a" }}</p>
      <img
        class="menu-bt"
        routerLink="/menu"
        src="../../assets/img/btn_menu.svg"
        alt="menu"
      />
    </div>
  </div>

  <div class="container-fluid container_box">
    <div class="table_group">
      <!-- search group-->
      <div class="search_group">
        <div class="search">
          <img
            class="search_icon"
            src="../../assets/img/smart_factory/bi_search.svg"
            alt="search-icon"
          />
          <input matInput placeholder="Search" #input />
        </div>

        <!-- 下拉選單 Section -->
        <div class="select_tag">
          <label>Section</label>
          <select (change)="getModelName($event.target.value)">
            <option selected="selected">All</option>
            <option *ngFor="let item of allSectionName">{{ item }}</option>
            <!-- <option>Loading</option>
            <option>ATE</option>
            <option>ASSY</option>
            <option>PKA</option> -->
            <!-- <option *ngFor="let item of rankingModelNameArray" [value]="item">
            {{ item }}
          </option> -->
          </select>
        </div>

        <!-- 子層全部 展開/關閉 -->
        <div class="switch_expand">
          <label for="expand" class="checkbox_gourp">
            Expand:
            <input
              type="checkbox"
              name=""
              id="expand"
              class="checkbox_input"
              [checked]="isExpandChildStatus"
              [(ngModel)]="isExpandChildStatus"
              (change)="switchAllChildExpanded()"
            />
            <span class="checkbox_span"></span>
          </label>
        </div>

        <!-- 日期篩選器 -->
        <div class="date_range_picker">
          <h6 class="date_title">Date Filter:</h6>

          <mat-form-field appearance="fill">
            <mat-label>Enter a date range</mat-label>

            <mat-date-range-input
              [formGroup]="range"
              [min]="minDate"
              [max]="maxDate"
              [dateFilter]="familyDayFilter"
              [rangePicker]="picker"
            >
              <input
                matStartDate
                formControlName="start"
                placeholder="Start date"
              />
              <input
                matEndDate
                formControlName="end"
                placeholder="End date"
                (dateChange)="getRangeDate(range.value.start, range.value.end)"
              />
            </mat-date-range-input>

            <mat-datepicker-toggle matSuffix [for]="picker">
            </mat-datepicker-toggle>

            <mat-date-range-picker
              #picker
              startView="month"
              [startAt]="startDate"
            ></mat-date-range-picker>
          </mat-form-field>

          <div class="date_group">
            <p class="date_value">
              {{
                range.value.start === null
                  ? "- - -"
                  : (range.value.start | date: "YYYY/MM/dd")
              }}
            </p>
            <span class="date_span"> ~ </span>
            <p class="date_value">
              {{
                range.value.end === null
                  ? "- - -"
                  : (range.value.end | date: "YYYY/MM/dd")
              }}
            </p>
            <div class="default_button" (click)="setDefaultRangeDate()">
              Default
            </div>
          </div>
        </div>

        <!-- select 欄位篩選器 -->
        <div class="select">
          <img
            class="select_icon"
            src="../../../assets/img/btn_table_column.svg"
            alt="Group"
            (click)="selectClickIcon()"
          />
          <div
            class="select_choice"
            [ngClass]="{ select_choice_show: selected }"
            *ngIf="displayedColumns as item"
          >
            <p class="select_tip">Column display :</p>

            <label class="checkbox_gourp">
              <input
                (change)="selectCheckbox($event)"
                class="checkbox_input"
                type="checkbox"
                name="select_name1"
                value="duration"
                id=""
              />
              <span class="checkbox_span"></span>
              Duration
            </label>

            <label class="checkbox_gourp">
              <input
                (change)="selectCheckbox($event)"
                checked
                class="checkbox_input"
                type="checkbox"
                name="select_name1"
                value="section"
                id=""
              />
              <span class="checkbox_span"></span>
              Section
            </label>

            <label class="checkbox_gourp">
              <input
                (change)="selectCheckbox($event)"
                checked
                class="checkbox_input"
                type="checkbox"
                name="select_name1"
                value="line"
                id=""
              />
              <span class="checkbox_span"></span>
              Line
            </label>

            <label class="checkbox_gourp">
              <input
                (change)="selectCheckbox($event)"
                checked
                class="checkbox_input"
                type="checkbox"
                name="select_name1"
                value="targetOutput"
                id=""
              />
              <span class="checkbox_span"></span>
              MO Qty
            </label>

            <label class="checkbox_gourp">
              <input
                (change)="selectCheckbox($event)"
                checked
                class="checkbox_input"
                type="checkbox"
                name="select_name1"
                value="side"
                id=""
              />
              <span class="checkbox_span"></span>
              Side
            </label>

            <label class="checkbox_gourp">
              <input
                (change)="selectCheckbox($event)"
                checked
                class="checkbox_input"
                type="checkbox"
                name="select_name1"
                value="startTime"
                id=""
              />
              <span class="checkbox_span"></span>
              Start Time
            </label>

            <label class="checkbox_gourp">
              <input
                (change)="selectCheckbox($event)"
                checked
                class="checkbox_input"
                type="checkbox"
                name="select_name1"
                value="endTime"
                id=""
              />
              <span class="checkbox_span"></span>
              End Time
            </label>

            <label class="checkbox_gourp">
              <input
                (change)="selectCheckbox($event)"
                checked
                class="checkbox_input"
                type="checkbox"
                name="select_name1"
                value="restTime"
                id=""
              />
              <span class="checkbox_span"></span>
              Rest Time
            </label>

            <label class="checkbox_gourp">
              <input
                (change)="selectCheckbox($event)"
                checked
                class="checkbox_input"
                type="checkbox"
                name="select_name1"
                value="downTime"
                id=""
              />
              <span class="checkbox_span"></span>
              Down Time
            </label>

            <label class="checkbox_gourp">
              <input
                (change)="selectCheckbox($event)"
                checked
                class="checkbox_input"
                type="checkbox"
                name="select_name1"
                value="changeover"
                id=""
              />
              <span class="checkbox_span"></span>
              Changeover
            </label>

            <label class="checkbox_gourp">
              <input
                (change)="selectCheckbox($event)"
                checked
                class="checkbox_input"
                type="checkbox"
                name="select_name1"
                value="changeover_ie"
                id=""
              />
              <span class="checkbox_span"></span>
              Changeover(IE)
            </label>

            <label class="checkbox_gourp">
              <input
                (change)="selectCheckbox($event)"
                checked
                class="checkbox_input"
                type="checkbox"
                name="select_name1"
                value="actProductionTime"
                id=""
              />
              <span class="checkbox_span"></span>
              Act Prod Time
            </label>

            <label class="checkbox_gourp">
              <input
                (change)="selectCheckbox($event)"
                checked
                class="checkbox_input"
                type="checkbox"
                name="select_name1"
                value="operator"
                id=""
              />
              <span class="checkbox_span"></span>
              Operators
            </label>

            <label class="checkbox_gourp">
              <input
                (change)="selectCheckbox($event)"
                checked
                class="checkbox_input"
                type="checkbox"
                name="select_name1"
                value="cycleTime"
                id=""
              />
              <span class="checkbox_span"></span>
              Cycle Time
            </label>

            <label class="checkbox_gourp">
              <input
                (change)="selectCheckbox($event)"
                checked
                class="checkbox_input"
                type="checkbox"
                name="select_name1"
                value="standardTime"
                id=""
              />
              <span class="checkbox_span"></span>
              Standard Time
            </label>

            <label class="checkbox_gourp">
              <input
                (change)="selectCheckbox($event)"
                checked
                class="checkbox_input"
                type="checkbox"
                name="select_name1"
                value="output"
                id=""
              />
              <span class="checkbox_span"></span>
              Output Qty
            </label>

            <label class="checkbox_gourp">
              <input
                (change)="selectCheckbox($event)"
                checked
                class="checkbox_input"
                type="checkbox"
                name="select_name1"
                value="efficiency"
                id=""
              />
              <span class="checkbox_span"></span>
              Efficiency
            </label>
          </div>
        </div>
      </div>

      <div class="table_scroll_box">
        <!-- 第一層 Table -->
        <div class="table_container mat-elevation-z8">
          <!-- API 回傳沒資料 -->
          <div *ngIf="outDataSource.data.length === 0" class="api_res_no_data">
            No Data
          </div>

          <!-- Table 吃 DataSource資料 -->
          <mat-table
            *ngIf="outDataSource.data.length > 0"
            #table
            [dataSource]="outDataSource"
            multiTemplateDataRows
            matSort
            #sort="matSort"
            matSortActive="startTime"
            matSortDirection="desc"
            (matSortChange)="sortData($event)"
          >
            <!-- MONo Column -->
            <ng-container matColumnDef="sn">
              <mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                disableClear="true"
                start="desc"
              >
                MO No.
              </mat-header-cell>
              <!-- Tooltip 兩種訊息換行 -->
              <!-- <mat-cell
                mat-raised-button
                matTooltipPosition="below"
                [matTooltip]="
                  'SN :' +
                  element.sn +
                  '
                  SN =>' +
                  element.product
                "
                [matTooltipClass]="'mat-tooltip-class-here'"
                *matCellDef="let element; let i = dataIndex"
                style="flex-grow: 1.5"
              >
                {{ this.dataFormatSvc.checkValDash(element.sn) }}
              </mat-cell> -->
              <mat-cell *matCellDef="let element; let i = dataIndex">
                {{ this.dataFormatSvc.checkValDash(element.sn) }}
              </mat-cell>
            </ng-container>

            <!-- Part No. Column -->
            <ng-container matColumnDef="product">
              <mat-header-cell
                mat-sort-header
                disableClear="true"
                start="desc"
                *matHeaderCellDef
                class=""
              >
                Part No.
              </mat-header-cell>
              <mat-cell *matCellDef="let element; let i = dataIndex" class="">
                {{ this.dataFormatSvc.checkValDash(element.product) }}
              </mat-cell>
            </ng-container>

            <!-- MO_Quantity Column -->
            <ng-container matColumnDef="targetOutput">
              <mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                disableClear="true"
                start="desc"
                style="justify-content: flex-end"
              >
                MO Qty
              </mat-header-cell>
              <mat-cell
                *matCellDef="let element; let i = dataIndex"
                style="justify-content: flex-end"
              >
                <span class="cell_text_right">
                  {{
                    this.dataFormatSvc.checkValDash(
                      element.formattedTargetOutput
                    )
                  }}
                </span>
              </mat-cell>
            </ng-container>

            <!-- Start Time Column -->
            <ng-container matColumnDef="startTime">
              <mat-header-cell
                *matHeaderCellDef
                disableClear="true"
                start="desc"
                class=""
              >
                Start time
              </mat-header-cell>
              <mat-cell *matCellDef="let element; let i = dataIndex" class="">
                <span>
                  {{
                    this.dataFormatSvc.checkValDash(element.formattedStartTime)
                  }}
                </span>
              </mat-cell>
            </ng-container>

            <!-- End Time Column -->
            <ng-container matColumnDef="endTime">
              <mat-header-cell
                *matHeaderCellDef
                disableClear="true"
                start="desc"
                class=""
              >
                End time
              </mat-header-cell>
              <mat-cell *matCellDef="let element; let i = dataIndex" class="">
                <span>
                  {{
                    this.dataFormatSvc.checkValDash(element.formattedEndTime)
                  }}
                </span>
              </mat-cell>
            </ng-container>

            <!-- Efficiency Column -->
            <tr matColumnDef="efficiency">
              <mat-header-cell
                *matHeaderCellDef
                disableClear="true"
                start="desc"
                style="justify-content: flex-end"
              >
                Efficiency
              </mat-header-cell>
              <mat-cell
                *matCellDef="let element; let i = dataIndex"
                style="justify-content: flex-end"
              >
                <span
                  class="cell_text_right"
                  [title]="element.efficiency"
                  [ngClass]="{
                    c_yellow:
                      +element.formattedEfficiency !== 0 &&
                      element.efficiency !== '-'
                        ? !+element.formattedEfficiency ||
                          +element.formattedEfficiency >= 102
                        : false,
                    c_red: +element.formattedEfficiency < 98
                  }"
                >
                  {{
                    this.dataFormatSvc.checkValDash(element.formattedEfficiency)
                  }}
                  %
                </span>
              </mat-cell>
            </tr>

            <!-- 第二層 table   Start ＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊ -->
            <ng-container matColumnDef="expandedDetail">
              <mat-cell
                *matCellDef="let row"
                class="innerTable"
                [@detailExpand]="expandHandler(row)"
              >
                <mat-table
                  [dataSource]="row.child"
                  multiTemplateDataRows
                  matSort
                  #innerTables
                  #innerSort="matSort"
                  matSortActive=""
                  matSortDirection=""
                  style="width: 100%"
                >
                  <!-- action Column -->
                  <ng-container matColumnDef="action">
                    <mat-header-cell
                      *matHeaderCellDef
                      style="flex: none; width: 35px"
                    >
                      <!-- action -->
                    </mat-header-cell>
                    <mat-cell
                      *matCellDef="let element"
                      style="flex: none; width: 35px"
                    ></mat-cell>
                  </ng-container>

                  <!-- Duration Column -->
                  <ng-container matColumnDef="duration">
                    <mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      disableClear="true"
                      start="desc"
                      style="justify-content: flex-end"
                    >
                      Duration<br />(hrs)
                    </mat-header-cell>
                    <mat-cell
                      *matCellDef="let element"
                      class=""
                      style="justify-content: flex-end"
                    >
                      {{
                        this.dataFormatSvc.checkValDash(
                          element.formattedDuration
                        )
                      }}
                    </mat-cell>
                  </ng-container>

                  <!-- Section Column -->
                  <ng-container matColumnDef="section">
                    <mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      disableClear="true"
                      start="desc"
                    >
                      Section
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <div
                        *ngIf="dataFormatSvc.shouldShowLink(element.section)"
                        [routerLink]="[
                          dataFormatSvc.getSectionLink(element.section)
                        ]"
                        [queryParams]="dataFormatSvc.getSectionParams(element)"
                        class="card_link"
                      >
                        {{ this.dataFormatSvc.checkValDash(element.section) }}
                      </div>

                      <div
                        *ngIf="!dataFormatSvc.shouldShowLink(element.section)"
                      >
                        {{ this.dataFormatSvc.checkValDash(element.section) }}
                      </div>
                    </mat-cell>
                  </ng-container>

                  <!-- line Column -->
                  <ng-container matColumnDef="line">
                    <mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      disableClear="true"
                      start="desc"
                    >
                      Line
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      {{ this.dataFormatSvc.checkValDash(element.line) }}
                    </mat-cell>
                  </ng-container>

                  <!-- Mo Qty Column -->
                  <ng-container matColumnDef="targetOutput">
                    <mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      disableClear="true"
                      start="desc"
                      style="justify-content: flex-end"
                    >
                      MO<br />Qty
                    </mat-header-cell>
                    <mat-cell
                      *matCellDef="let element"
                      class=""
                      style="justify-content: flex-end"
                    >
                      {{
                        this.dataFormatSvc.checkValDash(
                          element.formattedTargetOutput
                        )
                      }}
                    </mat-cell>
                  </ng-container>

                  <!-- Side Column -->
                  <ng-container matColumnDef="side">
                    <mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      disableClear="true"
                      start="desc"
                      style="justify-content: center"
                    >
                      Side
                    </mat-header-cell>
                    <mat-cell
                      *matCellDef="let element"
                      style="justify-content: center"
                    >
                      {{ this.dataFormatSvc.checkValDash(element.side) }}
                    </mat-cell>
                  </ng-container>

                  <!-- Start Time Column -->
                  <ng-container matColumnDef="startTime">
                    <mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      disableClear="true"
                      start="desc"
                    >
                      Start<br />Time
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      {{
                        this.dataFormatSvc.checkValDash(
                          element.formattedStartTime
                        )
                      }}
                    </mat-cell>
                  </ng-container>

                  <!-- End Time Column -->
                  <ng-container matColumnDef="endTime">
                    <mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      disableClear="true"
                      start="desc"
                    >
                      End<br />Time
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      {{
                        this.dataFormatSvc.checkValDash(
                          element.formattedEndTime
                        )
                      }}
                    </mat-cell>
                  </ng-container>

                  <!-- Rest Time Column -->
                  <ng-container matColumnDef="restTime">
                    <mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      disableClear="true"
                      start="desc"
                      style="justify-content: flex-end"
                    >
                      Rest<br />Time
                    </mat-header-cell>
                    <mat-cell
                      *matCellDef="let element"
                      style="justify-content: flex-end"
                    >
                      {{
                        this.dataFormatSvc.checkValDash(
                          element.formattedRestTime
                        )
                      }}
                    </mat-cell>
                  </ng-container>

                  <!-- Downtime Column -->
                  <ng-container matColumnDef="downTime">
                    <mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      disableClear="true"
                      start="desc"
                      style="justify-content: flex-end"
                    >
                      Down<br />Time
                    </mat-header-cell>
                    <mat-cell
                      *matCellDef="let element"
                      style="justify-content: flex-end"
                    >
                      <span class="">
                        {{
                          this.dataFormatSvc.checkValDash(
                            element.formattedDownTime
                          )
                        }}
                      </span>
                    </mat-cell>
                  </ng-container>

                  <!-- Changeover Column -->
                  <ng-container matColumnDef="changeover">
                    <mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      disableClear="true"
                      start="desc"
                      style="justify-content: flex-end"
                    >
                      Changeover
                    </mat-header-cell>
                    <mat-cell
                      *matCellDef="let element"
                      style="justify-content: flex-end"
                    >
                      <span class="">
                        {{
                          this.dataFormatSvc.checkValDash(
                            element.formattedChangeOver
                          )
                        }}
                      </span>
                    </mat-cell>
                  </ng-container>

                  <!-- Changeover(IE) Column -->
                  <ng-container matColumnDef="changeover_ie">
                    <mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      disableClear="true"
                      start="desc"
                      style="justify-content: flex-end"
                    >
                      Changeover(IE)
                    </mat-header-cell>
                    <mat-cell
                      *matCellDef="let element"
                      style="justify-content: flex-end"
                    >
                      <span class="">
                        {{
                          this.dataFormatSvc.checkValDash(
                            element.formattedChangeOverIE
                          )
                        }}
                      </span>
                    </mat-cell>
                  </ng-container>

                  <!-- Act Production Time Column -->
                  <ng-container matColumnDef="actProductionTime">
                    <mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      disableClear="true"
                      start="desc"
                      style="justify-content: flex-end"
                    >
                      Act Prod Time
                    </mat-header-cell>
                    <mat-cell
                      *matCellDef="let element"
                      style="justify-content: flex-end"
                    >
                      <span class="">
                        {{
                          this.dataFormatSvc.checkValDash(
                            element.formattedActProductionTime
                          )
                        }}
                      </span>
                    </mat-cell>
                  </ng-container>

                  <!-- Operators Column -->
                  <ng-container matColumnDef="operator">
                    <mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      disableClear="true"
                      start="desc"
                      style="justify-content: center"
                    >
                      Operators
                    </mat-header-cell>
                    <mat-cell
                      *matCellDef="let element"
                      style="justify-content: center"
                    >
                      <span class="" *ngIf="element.section === 'SMT'">0</span>
                      <span class="" *ngIf="element.section !== 'SMT'">
                        {{
                          this.dataFormatSvc.checkValDash(
                            element.formattedOperators
                          )
                        }}
                      </span>
                    </mat-cell>
                  </ng-container>

                  <!-- Act Time Column -->
                  <ng-container matColumnDef="actTime">
                    <mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      disableClear="true"
                      start="desc"
                      style="justify-content: flex-end"
                    >
                      Act<br />Working<br />Time
                    </mat-header-cell>
                    <mat-cell
                      *matCellDef="let element"
                      style="justify-content: flex-end"
                    >
                      <span class="">
                        {{
                          this.dataFormatSvc.checkValDash(
                            element.formattedactTime
                          )
                        }}
                      </span>
                    </mat-cell>
                  </ng-container>

                  <!-- CycleTime Column -->
                  <ng-container matColumnDef="cycleTime">
                    <mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      disableClear="true"
                      start="desc"
                      style="justify-content: flex-end"
                    >
                      Cycle<br />Time
                    </mat-header-cell>
                    <mat-cell
                      *matCellDef="let element"
                      matTooltipPosition="below"
                      [matTooltip]="element.cycleTime + ' s'"
                      [matTooltipClass]="'mat-tooltip-class-here'"
                      style="justify-content: flex-end"
                    >
                      <span class="">
                        {{
                          this.dataFormatSvc.checkValDash(
                            element.formattedCycleTime
                          )
                        }}
                      </span>
                    </mat-cell>
                  </ng-container>

                  <!-- StandardTime Column -->
                  <ng-container matColumnDef="standardTime">
                    <mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      disableClear="true"
                      start="desc"
                      style="justify-content: flex-end"
                    >
                      Standard<br />Time
                    </mat-header-cell>
                    <mat-cell
                      *matCellDef="let element"
                      style="justify-content: flex-end"
                    >
                      <span class="">
                        {{
                          this.dataFormatSvc.checkValDash(
                            element.formattedStandardTime
                          )
                        }}
                      </span>
                    </mat-cell>
                  </ng-container>

                  <!-- Output Qty Column -->
                  <ng-container matColumnDef="output">
                    <mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      disableClear="true"
                      start="desc"
                      style="justify-content: flex-end"
                    >
                      Output Qty
                    </mat-header-cell>
                    <mat-cell
                      *matCellDef="let element"
                      style="justify-content: flex-end"
                    >
                      <span class="">
                        {{
                          this.dataFormatSvc.checkValDash(
                            element.formattedOutput
                          )
                        }}
                      </span>
                    </mat-cell>
                  </ng-container>

                  <!-- efficiency Column -->
                  <ng-container matColumnDef="efficiency">
                    <mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      disableClear="true"
                      start="desc"
                      style="justify-content: flex-end"
                    >
                      Efficiency
                    </mat-header-cell>
                    <mat-cell
                      *matCellDef="let element"
                      style="justify-content: flex-end"
                    >
                      <span
                        class=""
                        (click)="onClickEfficiency(element)"
                        [title]="element.efficiency"
                        [ngClass]="
                          efficiencyFontColor(+element.formattedEfficiency)
                        "
                      >
                        {{
                          this.dataFormatSvc.checkValDash(
                            element.formattedEfficiency
                          )
                        }}
                        %
                      </span>
                    </mat-cell>
                  </ng-container>

                  <mat-header-row
                    *matHeaderRowDef="innerDisplayedColumns"
                  ></mat-header-row>
                  <mat-row
                    *matRowDef="let row; columns: innerDisplayedColumns"
                    matRipple
                    class="element-row"
                  >
                  </mat-row>
                </mat-table>
              </mat-cell>
            </ng-container>
            <!-- 第二層 table   END ＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊ -->

            <!-- action "^" -->
            <ng-container matColumnDef="action">
              <mat-header-cell
                *matHeaderCellDef
                style="flex: none; width: 35px"
              >
                <!-- action -->
              </mat-header-cell>
              <mat-cell
                *matCellDef="let element"
                style="flex: none; width: 35px"
              >
                <!-- 判斷有沒有 children -->
                <ng-container *ngIf="element.child.length !== 0">
                  <button mat-icon-button [@iconExpand]="iconSwitch(element)">
                    <mat-icon>
                      <img
                        src="/assets/img/smart_factory/Arrow_right.svg"
                        alt=""
                      />
                    </mat-icon>
                  </button>
                </ng-container>
              </mat-cell>
            </ng-container>

            <!-- 表頭 sticky: true => fix ".mat-header-row" -->
            <mat-header-row
              *matHeaderRowDef="displayedColumns; sticky: true"
            ></mat-header-row>
            <mat-row
              *matRowDef="let row; columns: displayedColumns"
              matRipple
              class="element-row"
              (click)="rowClickSwitchIsExpanded(row)"
              [ngStyle]="{
                'background-color': row.isExpanded ? '#747474' : '#383838'
              }"
            >
            </mat-row>
            <mat-row
              *matRowDef="let row; columns: ['expandedDetail']"
              style="overflow: hidden"
              class="example-detail-row"
            >
            </mat-row>
          </mat-table>
        </div>
      </div>

      <!-- page navigation-->
      <mat-paginator
        class="paginator"
        #MatPaginator
        [showFirstLastButtons]="true"
        [length]="isTotalPageNum"
        [pageIndex]="queryObj.offset - 1"
        [pageSize]="12"
        (page)="onPaginateChange($event)"
      >
      </mat-paginator>
    </div>
  </div>

  <!-- Auto Refresh -->
  <div class="refresh">
    <div class="refresh_btn">
      <label>
        <span class="text">Auto Refresh</span>
        <input
          type="checkbox"
          class="checkbox"
          [checked]="pageAutoRefresh"
          (change)="switchPageAutoRefresh()"
        />
        <span class="btn-box">
          <span class="btn"></span>
        </span>
      </label>
    </div>
  </div>
</div>
